import { render } from "./CustomRadio.vue?vue&type=template&id=2c58623c"
import script from "./CustomRadio.vue?vue&type=script&lang=js"
export * from "./CustomRadio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/double-daywrap-newsystem-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__